import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@ui/Form";
import NumberInput from "@ui/NumberInput";
import { useMultiStepForm } from "@/hooks";
import { VoivodeshipSelect } from "@/components/Selects";

const PVSubform: FC = () => {
  const { t } = useTranslation();
  const { form } = useMultiStepForm();

  const isAdditionalInfoRequired = form.watch("step4.hasPvInstallation") === "true";

  return (
    <div className="flex flex-col gap-4 pt-1 sm:px-7" data-test="pv-subform">
      <FormField
        control={form.control}
        name="step4.installationPower"
        render={({ field }) => (
          <FormItem className="gap-1">
            <FormControl>
              <div className="space-y-0.5">
                <FormDescription>{t("step4.installationPower")}</FormDescription>
                <NumberInput
                  {...field}
                  value={field.value ?? ""}
                  dataTest="installation-power-input"
                  isError={Boolean(form.formState.errors.step4?.installationPower)}
                  className="sm:max-w-[172px]"
                  unit={t("MW")}
                  disabled={!isAdditionalInfoRequired}
                />
              </div>
            </FormControl>
            <FormMessage data-test="installation-power-error" />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="step4.inverterPower"
        render={({ field }) => (
          <FormItem className="gap-1">
            <FormControl>
              <div className="space-y-0.5">
                <FormDescription>{t("step4.inverterPower")}</FormDescription>
                <NumberInput
                  {...field}
                  dataTest="inverter-power-input"
                  value={field.value ?? ""}
                  isError={Boolean(form.formState.errors.step4?.inverterPower)}
                  className="sm:max-w-[172px]"
                  disabled={!isAdditionalInfoRequired}
                  unit={t("MW")}
                />
              </div>
            </FormControl>
            <FormMessage data-test="inverter-power-error" />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="step4.voivodeship"
        render={({ field }) => (
          <FormItem className="gap-1">
            <FormControl>
              <div className="space-y-0.5">
                <FormDescription>{t("step4.voivodeship")}</FormDescription>
                <VoivodeshipSelect
                  value={field.value ?? ""}
                  onChange={field.onChange}
                  className="w-full sm:w-[216px]"
                  disabled={!isAdditionalInfoRequired}
                  isError={Boolean(form.formState.errors.step4?.voivodeship)}
                  dataTest="voivodeship-select"
                />
              </div>
            </FormControl>
            <FormMessage data-test="voivodeship-error" />
          </FormItem>
        )}
      />
    </div>
  );
};

export default PVSubform;
